import { Img } from "onnit-ui/lib/image";
import MediaContentShowcase from "onnit-ui/lib/module/MediaContentShowcase";
import Video from "onnit-ui/lib/video/Video";
import React from "react";
import Media from "react-media";
import useOnnitContext from "onnit-ui/lib/hooks/useOnnitContext";
import herbs from "./herbs";

export default function () {
    const onnitContext = useOnnitContext();

    if (!onnitContext) return null;

    const IMG_URL = onnitContext.url.cdn.static_images + "/product-page/new-mood";
    const SCDN_URL = onnitContext.url.cdn.static + "/images/product-page/new-mood";

    return (
        <MediaContentShowcase
            mt={[6, 6, 8]}
            mb={[6, 6, 10]}
            items={herbs.map((x) => {
                let copy = { ...x };
                copy.image = `${IMG_URL}/${copy.image}`;
                return copy;
            })}
            activeColor="white"
            textColor="grays.3"
            bgMedia={
                <Media query="(min-width: 768px)">
                    {(matches) =>
                        matches ? (
                            <Video
                                autoPlay
                                loop
                                muted
                                playsInline
                                poster={`${IMG_URL}/ingredientsBG.png?q=40`}>
                                <source src={`${SCDN_URL}/ingredientsBG.mp4`} type="video/mp4" />
                            </Video>
                        ) : (
                            <Img
                                alt="mountain range"
                                placeholder={[754, 208]}
                                src={`${IMG_URL}/ingredientsBG.png?q=40`}
                            />
                        )
                    }
                </Media>
            }
        />
    );
}
